export default "__VITE_ASSET__BCSBgxb$__"